import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { getServiceOptionSort, serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { AppTableCardsSorting } from '../../../sharedComponents/table/AppTableCardsSorting';
import { TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { serviceOptionColumnDefinition, ServiceOptionsTableColumns } from './ServiceOptionsTableColumns';

export const ServiceOptionCardsSorting = () => {
    const dispatch = useAppDispatch();
    const sorting = useAppSelector(getServiceOptionSort);

    return (
        <AppTableCardsSorting
            columnDefinition={serviceOptionColumnDefinition}
            sorting={sorting}
            setSorting={(sort: TableSort<ServiceOptionsTableColumns>) =>
                dispatch(serviceOrdersSlice.actions.setSortingForServiceOptions({ sort }))
            }
        />
    );
};
